import { createAction, props } from "@ngrx/store";
import { IPageCount } from "src/app/shared/models/page.model";
import { ICompaniesGroups, IGroupFilter, IGroupFilterRequest } from "../models/companies-groups.model";
import { APIResponse } from "src/app/core/models/api-response";


// Fetch  Companies Groups
export const FetchCompaniesGroups = createAction(
  '[ CompaniesGroups ] - Companies Groups',
  props<{ includes?: Array<string> }>()
);
export const FetchCompaniesGroupsSuccess = createAction(
    '[ CompaniesGroups ] - Companies Groups Success ',
    props<{ allCompaniesGroups: APIResponse<ICompaniesGroups> }>()
);
export const FetchCompaniesGroupsError = createAction(
    '[ CompaniesGroups ] - Companies Groups Error',
    props<{ error: any }>()
);


// Fetch All Companies Groups
export const FetchAllCompaniesGroups = createAction(
    '[ CompaniesGroups ] -  All Companies Groups',
    props<{ page: IPageCount, filter?: IGroupFilterRequest, key?: string | undefined }>()
);
export const FetchAllCompaniesGroupsSuccess = createAction(
    '[ CompaniesGroups ] - All Companies Groups Success ',
    props<{ companiesGroups: APIResponse<ICompaniesGroups> }>()
);
export const FetchAllCompaniesGroupsError = createAction(
    '[ CompaniesGroups ] - All Companies Groups Error',
    props<{ error: any }>()
);


// Add Companies Groupe
export const AddCompaniesGroupe = createAction(
    '[ CompaniesGroups ] - Add Companies Groupe',
    props<{ payload: any }>()
);
export const AddCompaniesGroupeSuccess = createAction(
    '[ CompaniesGroups ] - Add Companies Groupe Success',
    props<{ companiesGroup: ICompaniesGroups }>()
);
export const AddCompaniesGroupeError = createAction(
    '[ CompaniesGroups ] - Add Companies Groupe Error',
    props<{ error: any }>()
);

// get Companies Groupe by id
export const GetCompaniesGroupeById = createAction(
    '[ CompaniesGroups ] - GetCompaniesGroupeById',
    props<{ id: number }>()
);
export const GetCompaniesGroupeByIdSuccess = createAction(
    '[ CompaniesGroups ] - GetCompaniesGroupeById Success ',
    props<{ companiesGroup: ICompaniesGroups }>()
);
export const GetCompaniesGroupeByIdError = createAction(
    '[ CompaniesGroups ] - GetCompaniesGroupeById Error',
);

// eidit Companies Groupe
export const EditCompaniesGroupe = createAction(
    '[ CompaniesGroups ] - EditCompaniesGroupe',
    props<{ id: number, payload: any }>()
);
export const EditCompaniesGroupeSuccess = createAction(
    '[ CompaniesGroups ] - EditCompaniesGroupe Success ',
    props<{ companiesGroup: ICompaniesGroups }>()
);
export const EditCompaniesGroupeError = createAction(
    '[ CompaniesGroups ] - EditCompaniesGroupe Error',
);

// delete CompaniesGroups
export const DeleteCompaniesGroups = createAction(
    '[ CompaniesGroups ] - DeleteCompaniesGroups',
    props<{ id?: number }>()
);
export const DeleteCompaniesGroupsSuccess = createAction(
    '[ CompaniesGroups ] - DeleteCompaniesGroups Success '
);
export const DeleteCompaniesGroupsError = createAction(
    '[ CompaniesGroups ] - DeleteCompaniesGroups Error',
);
// loader action
export const SetGroupsLoader = createAction(
    '[ CompaniesGroups ] - SetLoading',
    props<{ isLoading: boolean }>()
);
export const SetSearchGroupLoader = createAction(
    '[ Loader ] - SearchLoader',
    props<{ isLoading: boolean }>()
);


// Filters
export const SetGroupFilter = createAction(
    '[ Filters ] - SetGroupFilter',
    props<{ keyword: string, advanced: IGroupFilter | null }>()
);

// search
export const SetGroupSearch = createAction(
    '[ Search ] - SetGroupSearch',
    props<{ search: string }>()
);
